/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { Link } from 'react-router';
import dashboardActions from 'loraactions/dashboard';
import callAPI from '@/api/callAPI';
import Chart from '../Chart';
import styles from './styles.scss';

const propTypes = {
  appState: PropTypes.object.isRequired,
  dashboardState: PropTypes.object.isRequired,
  pushState: PropTypes.func.isRequired,
  getDeveui: PropTypes.func.isRequired,
  dashId: PropTypes.string.isRequired,
  appId: PropTypes.string.isRequired,
  onDeleteSuc: PropTypes.func.isRequired,
  reset: PropTypes.any,
};

const defaultProps = {
  reset: 0,
};

class Charts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      animation: false,
      appState: props.appState,
      ext: { charts: [] },
      status: 'pending',
      dashboardState: props.dashboardState,
    };
  }

  componentWillMount() {
    this.loadDetail();
  }

  componentWillReceiveProps(nextProps) {
    const { appState, dashboardState, reset } = nextProps;
    if (appState !== this.props.appState) {
      this.setState({ appState });
    }
    if (dashboardState !== this.props.dashboardState) {
      this.setState({ dashboardState });
    }
    if (reset !== this.props.reset) {
      this.loadDetail();
    }
  }

  loadDetail() {
    const { dashId, getDeveui } = this.props;
    callAPI({ endpoint: `/lora/dashboards/${dashId}`, method: 'get' })
      .then((res) => {
        const ext = JSON.parse(res.ext);
        this.setState({ ext });
        getDeveui(ext.deveui);
        _.delay(() => {
          this.setState({ animation: true });
        }, 10);
      })
      .catch(() => {});
  }

  handleDeleteDps(e, dps) {
    e.stopPropagation();
    e.preventDefault();
    const { dashboardState: { data: { id } } } = this.state;
    let { ext } = this.state;
    const charts = _.filter(ext.charts, item => item.type !== dps);
    ext = { ...ext, charts };
    const param = {
      endpoint: `/lora/dashboards/${id}`,
      method: 'PUT',
      body: {
        ext: JSON.stringify(ext),
      },
    };
    callAPI(param)
      .then(() => {
        this.setState({ ext });
        this.props.onDeleteSuc(ext, dps);
      })
      .catch(() => {});
  }

  render() {
    const { animation, appState: { data }, ext } = this.state;
    if (ext.charts.length === 0 && !data) {
      return null;
    }
    const { pushState, dashId } = this.props;
    const height = Math.ceil(ext.charts.length / 3) * 260;
    const innerWidth = window.innerWidth;
    const charts = ext.charts.map((item, index) => {
      let style = {};
      const xF = innerWidth > 768 ? Math.floor(index % 3) * 100 : 0;
      const yF = innerWidth > 768 ? Math.floor(index / 3) * 100 : index * 100;
      const width = innerWidth > 768 ? '33.33%' : '100%';
      let dpsType;
      if (_.isArray(item.type)) {
        dpsType = item.type;
      } else {
        dpsType = [item.type];
      }
      let dpsShow = dpsType;
      if (dpsType.length > 3) {
        dpsShow = [];
        _.times(3, (n) => {
          dpsShow.push(dpsType[n]);
        });
      }
      // let gridTop = 0;
      // _.map(dpsTypeShow, () => {
      //   const dataShow = [];
      //   let n = 0;
      //   if (dpsTypeShow.length > 3) {
      //     n = 3;
      //     _.times(n, () => {
      //       dataShow.push(dpsTypeShow[0]);
      //       dpsTypeShow = _.filter(dpsTypeShow, t => (t !== dpsTypeShow[0]));
      //     });
      //   } else {
      //     n = dpsTypeShow.length;
      //     _.times(n, () => {
      //       dataShow.push(dpsTypeShow[0]);
      //       dpsTypeShow = _.filter(dpsTypeShow, t => (t !== dpsTypeShow[0]));
      //     });
      //   }
      //   dpsShow.push({ data: dataShow });
      // });
      // if (dpsShow.length !== 1) {
      //   _.times(dpsShow.length, (p) => {
      //     const topVal = p * 10;
      //     dpsShow[p].top = _.concat(topVal, '%').join('');
      //   });
      //   const topgrid = ((_.ceil(dpsShow.length / 3) - 2) * 10) + 25;
      //   gridTop = _.concat(topgrid, '%').join('');
      // } else {
      //   gridTop = 30;
      // }
      if (animation) {
        style = Object.assign({}, style, { transform: `translate(${xF}%,${yF}%)`, width, height: '260px' });
      }
      return (
        <Link
          key={`${item.type}-${String(index)}`}
          className="clearfix"
          styleName="boardItem"
          style={style}
          onClick={() => pushState(`/application/${data.id}/dashboard/${dashId}/${item.type}`)}
        >
          <p className="clearfix" styleName="chart-title">
            {/*<span>{name}</span>*/}
            <span                                                      // eslint-disable-line
              className="fa fa-trash-o pull-right"
              styleName="delete"
              onClick={e => this.handleDeleteDps(e, item.type)}
            />
          </p>
          <Chart
            dps={dpsType}
            dpsShow={[{ data: dpsShow }]}
            // gridTop={30}
            showPanel={false}
            dashId={dashId}
            appId={data.id}
          />
        </Link>
      );
    });

    return (
      <div styleName="itemLayout" style={{ height: `${height}px` }}>
        {charts}
      </div>
    );
  }
}

Charts.propTypes = propTypes;
Charts.defaultProps = defaultProps;

const mapStateToProps = state => ({
  appState: state.app.getApp,
  dashboardState: state.dashboard.getDashboard,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  getDeveui: dashboardActions.getDeveui,
};

export default connect(mapStateToProps,
  mapDispatchToProps,
)(CSSModules(Charts,
  styles,
  { allowMultiple: true },
));





// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DashBoardView/coms/Charts/index.jsx